import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { AnalyticsModule } from 'libs/analytics/src/lib/analytics.module';
import { EnhancedHelpModule } from 'libs/enhanced-help/src/lib/enhanced-help.module';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MissionWorkflowList } from './mission-workflow-list/mission-workflow-list.component';
import { WorkflowDialoguesService } from './workflow-dialogues.service';
import { WorkflowEditDialogue } from './workflow-edit/workflow-edit-dialogue.component';
import { WorkflowStepDetails } from './workflow-step-details/workflow-step-details.component';

@NgModule({
    imports: [
        CommonModule,
        LoadingIndicatorModule,
        SharedUiModule,
        FormsModule,
        ReactiveFormsModule,
        ValidationModule,
        TabsModule,
        NgSelectModule,
        TooltipModule,
        DragDropModule,
        EnhancedHelpModule,
        AnalyticsModule
    ],
    providers: [WorkflowDialoguesService],
    bootstrap: [],
    declarations: [
        MissionWorkflowList,
        WorkflowEditDialogue,
        WorkflowStepDetails
    ],
    exports: [MissionWorkflowList, WorkflowStepDetails]
})
export class WorkflowModule {}
